/**
 * Internal dependencies
 */
import { getExtraSegmentationInfo } from '../index';
import type { Attributes } from '../../../../../../packages/segmentation-rule-library/rules/operating-system/types';

export const type = 'nab/operating-system';

export function validate( attributes: Attributes ): boolean {
	const { condition, values } = attributes;

	const visitorOS = getExtraSegmentationInfo().os;
	if ( 'string' !== typeof visitorOS ) {
		return false;
	}

	switch ( condition ) {
		case 'is-equal-to':
			return values.some( ( { value } ) => isSameOS( value, visitorOS ) );

		case 'is-not-equal-to':
			return values.every(
				( { value } ) => ! isSameOS( value, visitorOS )
			);
	}
}

function isSameOS( operatingSystemName: string, visitorOS?: string ) {
	if (
		'Windows' === operatingSystemName &&
		'string' === typeof visitorOS &&
		visitorOS.startsWith( 'Windows' )
	) {
		return true;
	}

	return operatingSystemName === visitorOS;
}
